import React from 'react';
import { Select, Checkbox, useMultipleSelect, Typography } from '@vtblife/uikit';
import { SelectMode, OptionType, SelectProps, Toggle } from '@vtblife/uikit/legacy';
import { Rooms } from '@search/filter-enums/enums/Rooms';
import classname from '@search/classname/src';
import { RoomFilter } from '../../../../models/Filter';
import { KitchenAreaFilter } from '../../../../models/Filter';
import { renderCustomTitle } from './DesktopRoomsTypeFilterView';

import './DesktopRoomsTypeNewFilterView.css';

const cn = classname.bind(null, 'DesktopRoomsTypeNewFilterView');

interface IProps {
    filter: RoomFilter;
    kitchenAreaFilter: KitchenAreaFilter;
    onChange: (filter: RoomFilter | KitchenAreaFilter) => void;
    isRent?: boolean;
}

export const SELECT_OPTIONS: OptionType<Rooms>[] = [
    { label: 'Студия', value: Rooms.STUDIO },
    { label: '1 комната', value: Rooms.ROOM_1 },
    { label: '2 комнаты', value: Rooms.ROOM_2 },
    { label: '3 комнаты', value: Rooms.ROOM_3 },
    { label: '4 комнаты', value: Rooms.ROOM_4 },
    { label: '5+ комнат', value: Rooms.ROOM_5_AND_MORE },
    { label: 'Свободная планировка', value: Rooms.OPEN_PLAN }
];

const getLabel = (v: Rooms) => {
    switch (v) {
        case Rooms.STUDIO:
            return 'Студия';
        case Rooms.ROOM_1:
            return '1';
        case Rooms.ROOM_2:
            return '2';
        case Rooms.ROOM_3:
            return '3';
        case Rooms.ROOM_4:
            return '4';
        case Rooms.ROOM_5_AND_MORE:
            return '5+';
        case Rooms.OPEN_PLAN:
            return 'Свободная планировка';
        default:
            return '1';
    }
};

type Mutable<T> = {
    -readonly[P in keyof T]: T[P]
};

export const DesktopRoomsTypeNewFilterView: React.FC<IProps> = ({
    filter,
    kitchenAreaFilter,
    onChange,
    isRent = false
}) => {
    const isToggled = (kitchenAreaFilter?.value?.from ?? 0) >= 15;
    const isStudio = filter.rooms.includes(Rooms.STUDIO);

    const handleRoomChange = React.useCallback((value: readonly Rooms[]) => {
        onChange(new RoomFilter(value));
    }, [ onChange ]);

    const handleEuroPlanChange = React.useCallback((value: boolean) => {
        onChange(new KitchenAreaFilter({ from: value ? 15 : null, to: null }));
    }, [ onChange ]);

    const {
        handleChange: handleRoomSelectChange,
        is
    } = useMultipleSelect<Rooms>(
        handleRoomChange,
        {
            selected: filter.rooms as Mutable<Rooms[]>
        }
    );

    return (
        <Select mode='multiple'>
            <Select.Button dataTest='rooms-trigger'>
                {filter.rooms.length > 0 ?
                    renderCustomTitle(SELECT_OPTIONS.filter(({ value }) => filter.rooms.includes(value))) :
                    'Комнат'
                }
            </Select.Button>
            <Select.Content>
                <div className={cn('checkbox-group')}>
                    {SELECT_OPTIONS.map(({ value, label }) => (
                        <div
                            key={`${value}-${label}`}
                            className={cn('checkbox-item', { area: value === Rooms.OPEN_PLAN })}
                        >
                            <Checkbox
                                variant='filter'
                                name={label}
                                value={is(value)}
                                onChange={(checked) => handleRoomSelectChange(value, checked, null)}
                            >
                                <Typography>
                                    {getLabel(value)}
                                </Typography>
                            </Checkbox>
                        </div>
                    ))}
                    {isRent ? null : (
                        <>
                            <span className={cn('line')} />
                            <div className={cn('toggle')}>
                                <Typography onClick={isStudio ? undefined : () => handleEuroPlanChange(! isToggled)}>
                                    Европланировка
                                </Typography>
                                <Toggle
                                    value={isToggled}
                                    onChange={handleEuroPlanChange}
                                    disabled={filter.rooms.includes(Rooms.STUDIO)}
                                />
                            </div>
                        </>
                    )}
                </div>
            </Select.Content>
        </Select>
    );
};
